import cn from 'classnames';

import DeviceExpired from '../../../device/DeviceExpired';
import { formatMbToGb } from '../../../../utils/formatters';

import styles from './styles.module.scss';

const DeviceItem = ({
  deviceDetails,
  type,
  selected,
  clickHandler,
  ...props
}) => {
  const defaultImagePath = 'images/products/default-product-image.png';
  const device_info = deviceDetails?.meta?.device_info || {};
  const sub_id = deviceDetails?.id;
  const meta = deviceDetails?.meta || {};
  const total_usage = meta?.usage?.total || 0;
  const planAmount = formatMbToGb(total_usage);
  const expired = !!deviceDetails?.cancelled_at;
  const { title, image } = meta;
  const { connection_status_name } = device_info;

  const handleClick = () => {
    return clickHandler(sub_id || null);
  };

  if (type === 'all') {
    return (
      <li
        className={cn(styles.deviceItem, styles.deviceItemAll, {
          [styles.deviceItemActive]: selected,
        })}
        onClick={handleClick}
        {...props}
      >
        All Devices
      </li>
    );
  } else {
    return (
      <li
        className={cn(styles.deviceItem, {
          [styles.deviceItemActive]: selected,
        })}
        onClick={handleClick}
        {...props}
      >
        {image && !expired ? (
          <img src={image} alt={title} />
        ) : (
          <img src={defaultImagePath} alt="..." />
        )}
        <div className={styles.deviceItemContent}>
          <div className={styles.deviceItemContentTitle}>
            {title ? title : 'Connection Unavailable'}
          </div>
          <div className={styles.deviceItemContentBottom}>
            <div className={styles.deviceItemContentItem}>
              <span>Subscription Status:</span>
              {connection_status_name === 'Online' ? (
                <div
                  className={cn(
                    styles.deviceItemContentStatus,
                    styles.deviceItemContentStatusActive,
                  )}
                >
                  Active
                </div>
              ) : (
                <div className={styles.deviceItemContentStatus}>Disabled</div>
              )}
            </div>

            <div className={styles.deviceItemContentSeparator}></div>
            {expired ? (
              <DeviceExpired></DeviceExpired>
            ) : (
              <div className={styles.deviceItemContentItem}>
                <span>Plan:</span>
                <div className={styles.deviceItemContentPlan}>
                  {planAmount}GB Plan
                </div>
              </div>
            )}
          </div>
        </div>
      </li>
    );
  }
};

export default DeviceItem;
